import React, { useState } from 'react';
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Select,
  Textarea,
  Button,
  useToast,
  Heading
} from '@chakra-ui/react';
import { addVideo } from '../../../../../services/videoService';
import videoCategories from '../../../../../data/videoCategories.json'

const categories = videoCategories
const AddVideoForm = ({clerkId}) => {
  const [videoDetails, setVideoDetails] = useState({
    url: '',
    category: '',
    description: '',
    title: '',
    display_order: 0,
  });
  const toast = useToast();

  const handleChange = (field, value) => {
    setVideoDetails(prev => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleAddVideo = async () => {
    try {
      const response = await addVideo(clerkId, videoDetails);
      if (response.updated === true) {
        toast({
          title: 'Video added.',
          description: 'The video has been added successfully.',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        setVideoDetails({ url: '', category: '', description: '', title: '', display_order: 0, });
      } else {
        toast({
          title: 'Error adding video.',
          description: 'There was an error adding the video.',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: 'Error.',
        description: 'An unexpected error occurred.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      console.error('Error adding video: ', error);
    }
  };

  return (
    <Box>
      <Heading>Add videos</Heading>
      <FormControl id="video-url" mb={4}>
        <FormLabel>Video URL</FormLabel>
        <Input
          value={videoDetails.url}
          onChange={(e) => handleChange('url', e.target.value)}
          placeholder="Enter video URL"
        />
      </FormControl>

      <FormControl id="video-title" mb={4}>
        <FormLabel>Title</FormLabel>
        <Input
          value={videoDetails.title}
          onChange={(e) => handleChange('title', e.target.value)}
          placeholder="Enter video title"
        />
      </FormControl>

      <FormControl id="video-category" mb={4}>
        <FormLabel>Category</FormLabel>
        <Select
          value={videoDetails.category}
          onChange={(e) => handleChange('category', e.target.value)}
          placeholder="Select a category"
          paddingRight="0.8rem"
        >
          {categories.map((category, index) => (
            <option key={index} value={category}>
              {category}
            </option>
          ))}
        </Select>
      </FormControl>

      <FormControl id="display-order" mb={4}>
        <FormLabel>Display Order</FormLabel>
        <Input
          value={videoDetails.title}
          onChange={(e) => handleChange('display_order', e.target.value)}
          placeholder="Enter Display Order Number"
        />
      </FormControl>
      <FormControl id="video-description" mb={4}>
        <FormLabel>Description</FormLabel>
        <Textarea
          value={videoDetails.description}
          onChange={(e) => handleChange('description', e.target.value)}
          placeholder="Enter video description"
        />
      </FormControl>

      <Button colorScheme="blue" onClick={handleAddVideo}>
        Add Video
      </Button>
    </Box>
  );
};

export default AddVideoForm;
